import { apiClient } from '~shared/api/createApiClient';
import { ApiError } from '~shared/api/types';

import { LoginFormData } from './model/login.schema';
import { ResetTokenFormData } from './model/reset-token.schema';
import { ResetFormData } from './model/reset.schema';

type LoginCipBody = { cip: string; email: string; password: string };
type LoginCipResponse = { pharmacyId: string; cookie: string };

export const postLoginCip = async (
  body: LoginCipBody
): Promise<LoginCipResponse> => {
  try {
    return await apiClient.post<LoginCipResponse>(
      '/direct-auth/from-cip',
      body,
      {
        pharmacyId: '',
        withoutPharmacyPrefix: true,
      }
    );
  } catch (error) {
    if (error instanceof ApiError) {
      throw new ApiError('Connexion impossible', error.status, error.response);
    }
    throw error;
  }
};

export const postReset = (
  pharmacyId: string,
  { email }: ResetFormData
): Promise<void> => {
  const formData = new FormData();

  formData.append('email', email);

  return apiClient.post<void>('/reset', formData, { pharmacyId });
};

export const postResetToken = (
  pharmacyId: string,
  values: ResetTokenFormData,
  token: string
): Promise<void> =>
  apiClient.post<void>(`/reset/${token}`, values, { pharmacyId });

export const postAfterOTP = (
  pharmacyId: string,
  values: ResetTokenFormData
): Promise<void> =>
  apiClient.post<void>('/define-password', values, { pharmacyId });

export const logout = (pharmacyId: string): Promise<void> => {
  return apiClient.get<void>('/logout', { pharmacyId });
};

export const postLogin = (
  pharmacyId: string,
  credentials: LoginFormData
): Promise<void> => {
  const formData = new FormData();

  formData.append('username', credentials.username);
  formData.append('password', credentials.password);

  return apiClient.post<void>('/authenticate/v2/pharmacyIdentity', formData, {
    pharmacyId,
  });
};
